// src/components/AnimatedLoader.js
import React from 'react';
import Logo from './Logo';

const AnimatedLoader = () => {
  return (
    <div className="animated-loader-container">
      <div className="animated-loader-bg">
        <div className="animated-loader-shapes">
          <div className="loader-shape shape-1"></div>
          <div className="loader-shape shape-2"></div>
          <div className="loader-shape shape-3"></div>
        </div>
        
        <div className="animated-loader-content">
          <div className="loader-logo-wrapper">
            {/* Orbiting Ellipses */}
            <div className="orbit-container">
              <div className="orbit orbit-1">
                <div className="ellipse ellipse-1"></div>
              </div>
              <div className="orbit orbit-2">
                <div className="ellipse ellipse-2"></div>
              </div>
              <div className="orbit orbit-3">
                <div className="ellipse ellipse-3"></div>
              </div>
            </div>
            
            {/* Center Logo */}
            <div className="loader-logo-glow">
              <Logo size="large" />
            </div>
          </div>
          
          
          <div className="loader-version">v2.0.0</div>
        </div>
      </div>
    </div>
  );
};

export default AnimatedLoader;